module.exports = __webpack_public_path__ + "img/retailIFive.36124470.png";